import "starknet";
import "./lastConnected-b964dc30.js";
import { I as m } from "./index-25202aca.js";
export {
  m as InjectedConnector
};
